export default [
    {
        path: '/class-now',
        name: 'class-now',
        component: () => import('./views/ClassNow.vue'),
        meta: {
            title: 'Localizador de aulas',
            icon: 'mdi-map-marker-radius',
            breadcrumbs: [
                { text: 'Atendimento', disabled: true, href: '/' },
                { text: 'Localizador de aulas', disabled: true, href: '/' },
            ],
        }
    }
]
